import { useRef, useEffect } from 'react';

const baseAnimationDuration = 1000;

export const useTextAnimation = ({ texts, speedFactor = 1 }: { texts: string[]; speedFactor?: number }) => {
  const animatedTextElRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const subTextElement = animatedTextElRef.current;
    if (!subTextElement || texts.length <= 1) {
      return;
    }

    let index = 0;
    let timeout: ReturnType<typeof setTimeout>;

    const animationDuration = baseAnimationDuration * speedFactor;
    const interval = setInterval(() => {
      const keyframes: Keyframe[] = [
        { opacity: 1, transform: 'translateX(0px)', offset: 0 },
        { opacity: 0, transform: 'translateX(-50px)', offset: 0.5 },
        { opacity: 0, transform: 'translateX(0px)', offset: 0.75 },
        { opacity: 1, transform: 'translateX(0px)', offset: 1 },
      ];

      subTextElement.animate(keyframes, { duration: animationDuration });
      timeout = setTimeout(() => {
        index = (index + 1) % texts.length;
        subTextElement.textContent = texts[index];
      }, animationDuration / 2);
    }, animationDuration * 2);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [texts, speedFactor]);

  return animatedTextElRef;
};
